import React from 'react';
import PropTypes from 'prop-types';
import { GridItem, Text, Flex, Container } from '@chakra-ui/react';
import MediaBackground from '@repo/ui-components/dept/molecules/MediaBackground';

function ImageHeroesSecondary({ block }) {
  const { headline, copy, background, alignment } = block;

  const handleAlignment = (
    leftValue,
    centerValue,
    rightValue,
    defaultAlignment
  ) => {
    const values = {
      left: leftValue,
      center: centerValue,
      right: rightValue,
    };

    return {
      base: defaultAlignment ?? leftValue,
      lg: values[alignment] || defaultAlignment,
    };
  };

  return (
    <Container as="section" id="image-heroes-secondary" py={14}>
      <MediaBackground
        background={background}
        mb={{ base: '3rem', lg: '5rem' }}
        minH={{ base: '21.4rem', lg: '35.5rem' }}
      >
        <GridItem
          as={Flex}
          colSpan={{ base: 12, lg: 6 }}
          rowSpan={{ base: 1, lg: 1 }}
          gridColumnStart={handleAlignment(1, 4, 7)}
          alignItems={handleAlignment('flex-start', 'center', 'flex-end')}
          textAlign={handleAlignment('left', 'center', 'right')}
          h="full"
          direction="column"
          justify="end"
          zIndex={1}
          p={{ base: 6, md: 16 }}
          pb={{ base: 10, md: null }}
        >
          {headline && (
            <Text as="h1" textStyle="display" color="typography.lighter" mb={2}>
              {headline}
            </Text>
          )}

          {copy && (
            <Text
              textStyle="bodyLarge"
              color="typography.lighter"
              fontWeight="bold"
            >
              {copy}
            </Text>
          )}
        </GridItem>
      </MediaBackground>
    </Container>
  );
}

ImageHeroesSecondary.propTypes = {
  block: PropTypes.shape({
    headline: PropTypes.string,
    copy: PropTypes.string,
    alt: PropTypes.string,
    image: PropTypes.shape({
      asset: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
}.isRequired;

export default ImageHeroesSecondary;
